import { PromiseStore } from './PromiseStore';

export const loadScript = (id: string, src: string, async = true) => {
    let scriptLoadingTask = PromiseStore.get('loadScript', id);

    const existingScript = Array.prototype.slice.call<HTMLCollectionOf<HTMLScriptElement>, [], HTMLScriptElement[]>(document.getElementsByTagName('script'))
        .find(m => m.src.toLowerCase() === src.toLowerCase());

    if (scriptLoadingTask) {
        return scriptLoadingTask;
    }

    if (existingScript) {
        return Promise.resolve();
    }

    scriptLoadingTask = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = async;
        script.id = id;
        script.onload = () => {
            resolve();
        };
        script.onerror = (err) => {
            reject(err);
        };
        script.src = src;
        document.body.appendChild(script);
    });

    PromiseStore.set(scriptLoadingTask, 'loadScript', id);

    return scriptLoadingTask;
};

export const loadStyle = (id: string, href: string) => {
    let scriptLoadingTask = PromiseStore.get('loadStyle', id);

    const existingScript = Array.prototype.slice.call<HTMLCollectionOf<HTMLLinkElement>, [], HTMLLinkElement[]>(document.getElementsByTagName('link'))
        .find(m => m.href.toLowerCase() === href.toLowerCase());

    if (scriptLoadingTask) {
        return scriptLoadingTask;
    }

    if (existingScript) {
        return Promise.resolve();
    }

    scriptLoadingTask = new Promise((resolve) => {
        const link = document.createElement('link');
        link.type = 'stylesheet';
        link.id = id;
        link.href = href;
        document.head.appendChild(link);
        resolve();
    });

    PromiseStore.set(scriptLoadingTask, 'loadStyle', id);

    return scriptLoadingTask;
};